/**
 * Adds `nice: true` to scale fields that don't already have explicit min/max,
 * restoring G2 v2 behavior where linear axes extend to "nice" round tick values
 * beyond the data range. G2 v4 defaults `nice` to false.
 * Skips fields with explicit min/max to avoid interfering with fixed ranges.
 */
export const withNiceScale = (cols: any): any => {
	if (!cols) return cols;
	const result = {};
	Object.keys(cols).forEach((key) => {
		const field = cols[key];
		const hasExplicitBounds = field && (field.min !== undefined || field.max !== undefined);
		result[key] = hasExplicitBounds ? field : { nice: true, ...field };
	});
	return result;
};

/**
 * Truncates a category-axis label to `maxChars`, ending in an ellipsis. G2 clips long labels
 * against the chart's left padding instead of shortening them.
 */
export const truncateCategoryLabel = (rawLabel: any, maxChars: number): string => {
	if (rawLabel === null || rawLabel === undefined) return '';
	const text = String(rawLabel);
	if (text.length <= maxChars) return text;
	return `${text.slice(0, maxChars - 1).trimEnd()}…`;
};
